import { api, generateCRUDInterface } from "aldoo-ra/API"

// Construct the endpoint
const crudAPI = api("crud")

// Generate the CRUD interface for StoreTransaction
const storeTransactionCRUD = generateCRUDInterface(crudAPI, "StoreTransaction")

// Override the get method to populate the user field and handle filtering
storeTransactionCRUD.Get = async (requestParams) => {
  const params = {
    ...requestParams,
    model: "StoreTransaction",
    populate: requestParams.populate || ["user"], // Populate user information by default, allow override
    // Don't filter deleted items as transactions shouldn't be soft-deleted
    // They should remain for audit purposes
  }
  return await crudAPI({ get: params })
}

export const StoreTransactionAPI = {
  /**
   * Get store transactions with filtering and pagination
   * @param {Object} requestFields - MongoDB-style query filters
   * @returns {Promise<Object>}
   */
  GetTransactions: async (requestFields = {}) => {
    const defaultFields = {
      sort: { created: -1 }, // Latest transactions first
      itemsPerPage: 25,
      page: 1,
      ...requestFields
    }

    try {
      const response = await storeTransactionCRUD.Get(defaultFields)
      return {
        result: true,
        data: response.data || [],
        totalItems: response.totalItems || 0
      }
    } catch (error) {
      console.error("Failed to fetch transactions:", error)
      return {
        result: false,
        data: [],
        totalItems: 0,
        error: error.message
      }
    }
  },

  /**
   * Search transactions by multiple fields
   * @param {string} searchQuery - Search query
   * @param {Object} filters - Additional filters
   * @returns {Promise<Object>}
   */
  SearchTransactions: async (searchQuery, filters = {}) => {
    try {
      const searchFields = [
        'product_id',
        'receipt_id',
        'type',
        'platform'
      ]

      const searchConditions = searchFields.map(field => ({
        [field]: { $regex: searchQuery, $options: 'i' }
      }))

      const requestFields = {
        match: {
          $or: searchConditions,
          ...filters
        },
        sort: { created: -1 }
      }
      
      const response = await storeTransactionCRUD.Get(requestFields)
      
      return {
        result: true,
        data: response.data || []
      }
    } catch (error) {
      console.error("Failed to search transactions:", error)
      return {
        result: false,
        data: [],
        error: error.message
      }
    }
  },

  /**
   * Get transaction statistics for summary
   * @param {Object} filters - Date range and other filters
   * @returns {Promise<Object>}
   */
  GetTransactionStats: async (filters = {}) => {
    try {
      // This would need a backend endpoint for aggregation
      // For now, return placeholder structure
      return {
        result: true,
        data: {
          totalTransactions: 0,
          totalValue: 0,
          byPlatform: {},
          byType: {},
          subscriptionRenewals: 0
        }
      }
    } catch (error) {
      console.error("Failed to get transaction stats:", error)
      return {
        result: false,
        data: null,
        error: error.message
      }
    }
  }
}

export default storeTransactionCRUD
